import React from 'react';
import { motion } from 'framer-motion';
import { GlassWaterIcon, PartyPopperIcon, TheaterIcon, TentIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
const references = [{
  type: 'Bar/Venue',
  icon: GlassWaterIcon,
  venue: '[Venue-Name]',
  date: '[Datum]',
  quote: '[Zitat folgt]'
}, {
  type: 'Privatveranstaltung',
  icon: PartyPopperIcon,
  venue: '[Event-Name]',
  date: '[Datum]',
  quote: '[Zitat folgt]'
}, {
  type: 'Kulturveranstaltung',
  icon: TheaterIcon,
  venue: '[Event-Name]',
  date: '[Datum]',
  quote: '[Zitat folgt]'
}, {
  type: 'Open-Air/Festival',
  icon: TentIcon,
  venue: '[Festival-Name]',
  date: '[Datum]',
  quote: '[Zitat folgt]'
}];
export function Referenzen() {
  return <div className="w-full min-h-screen py-16 px-4 sm:px-6 lg:px-8" data-id="element-244">
      <div className="max-w-5xl mx-auto" data-id="element-245">
        <motion.div {...fadeInUp} className="text-center mb-12" data-id="element-246">
          <h1 className="font-display text-5xl sm:text-6xl font-bold text-primary mb-6" data-id="element-247">
            Referenzen
          </h1>
          <div className="bg-[var(--color-accent-hover)] border border-accent rounded-lg p-6 max-w-2xl mx-auto" data-id="element-248">
            <p className="text-primary text-lg" data-id="element-249">Referenzen folgen in Kürze.</p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-250">
          {references.map((ref, index) => <motion.div key={ref.type} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-surface border border-border-base rounded-lg p-6" data-id="element-251">
              <div className="flex items-start gap-4 mb-4" data-id="element-252">
                <ref.icon size={32} className="text-accent flex-shrink-0" data-id="element-253" />
                <div className="flex-1" data-id="element-254">
                  <h3 className="font-display text-xl font-semibold text-primary mb-1" data-id="element-255">
                    {ref.type}
                  </h3>
                  <p className="text-muted text-sm mb-1" data-id="element-256">{ref.venue}</p>
                  <p className="text-muted text-xs" data-id="element-257">{ref.date}</p>
                </div>
              </div>

              <div className="pt-4 border-t border-border-base" data-id="element-258">
                <p className="text-muted italic text-sm" data-id="element-259">{ref.quote}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div {...fadeInUp} className="mt-12 text-center" data-id="element-260">
          <p className="text-muted mb-4" data-id="element-261">
            Für Referenzen und weitere Informationen kontaktiere uns direkt:
          </p>
          <a href="mailto:booking@tuesday-band.de" className="inline-block px-8 py-3 bg-secondary text-[var(--color-secondary-text)] font-medium rounded hover:bg-[var(--color-secondary-solid-hover)] transition-colors" data-id="element-262">
            booking@tuesday-band.de
          </a>
        </motion.div>
      </div>
    </div>;
}